import { useState } from 'react';

/**
 * Custom hook to manage alert messages in the application
 */
const useAlerts = () => {
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('info');

  // Show an alert message
  const showAlert = (message, severity = 'info') => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  // Close the alert
  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  // Helper for showing common alert types
  const showSuccess = (message) => showAlert(message, 'success');
  const showError = (message) => showAlert(message, 'error');
  const showWarning = (message) => showAlert(message, 'warning');
  const showInfo = (message) => showAlert(message, 'info');

  return {
    alertOpen,
    alertMessage,
    alertSeverity,
    showAlert,
    handleAlertClose,
    showSuccess,
    showError,
    showWarning,
    showInfo
  };
};

export default useAlerts; 